import { makeStyles } from "tss-react/mui";
import { EDeviceType, getThemeBreakpointByDeviceType } from "@utils/getThemeBreakpointByDeviceType";

export const useStyle = makeStyles()((theme) => ({
    card: {
        width: "100%",
        maxWidth: 600,
        marginBlock: theme.spacing(3),
        marginInline: theme.spacing(1),
        textAlign: "center",
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE)]: {
            marginInline: 0,
        },
    },
    offerIcon: {
        fontSize: theme.typography.h2.fontSize,
        marginRight: theme.spacing(2),
        width: 25,
        height: 35,
    },
    firstUsageDescription: {
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: 24,
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE)]: {
            fontSize: 20,
        },
    },
    list: {
        paddingTop: theme.spacing(3),
    },
    listItem: {
        color: theme.palette.secondary.main,
        height: 36,
        padding: theme.spacing(1, 0),
        "&:before": {
            content: "'·'",
            color: theme.palette.primary.main,
            fontSize: 100,
            verticalAlign: "middle",
            paddingRight: theme.spacing(2),
        },
    },
    button: {
        margin: theme.spacing(4, 0, 1, 0),
    },
}));
